import React from "react";
import ChartCard from "./ChartCard";
import { withTranslation } from "react-i18next";
import { convertToChartData, formatSizeUnits } from "../../helpers/utils";
import { EnvironmentInsight } from "../../models/Environment.model";

interface UnitObjactCpuProps {
  Unit : string;
  MultiplyBy: string;
}

interface CpuChartCardProps {
  source?: string;
  t?: any;
  environmentInsights?: EnvironmentInsight;
  selectedPod?: string;
  replicas?: number;
}

export const CPUChartCard = (props: CpuChartCardProps) => {
  const { t, environmentInsights, selectedPod, replicas } = props;

  var data_cpu_usage = null,
    maxOfCPU = null,
    unitObjectCPU: UnitObjactCpuProps | null = null,
    maxY: any;

  data_cpu_usage = props.source === "overview" ? 
    selectedPod &&
    environmentInsights && environmentInsights?.cpu_usages?.length > 0 &&
    environmentInsights.cpu_usages.filter(
      (itm : any) => itm.metric.namespace === selectedPod
    ) : selectedPod &&
    environmentInsights && environmentInsights?.cpu_usages?.length > 0 &&
    environmentInsights.cpu_usages.filter(
      (itm: any) => itm.metric?.pod ? itm.metric.pod === selectedPod : itm.metric?.container === selectedPod
    );
  maxOfCPU =
    data_cpu_usage && data_cpu_usage.length > 0
      ? Math.max(...data_cpu_usage[0].values.map((o: any) => o[1]), 0)
      : 0;
  unitObjectCPU = formatSizeUnits(maxOfCPU, 1);

  maxY =
     environmentInsights && environmentInsights?.total_cpu >= 1
      ? environmentInsights.total_cpu
      : environmentInsights && environmentInsights.total_cpu * parseInt(unitObjectCPU.MultiplyBy);
  maxY = props.source === "overview" && replicas ? maxY * replicas : maxY;

  return (
    <ChartCard
      title={t("Environment.OverviewTab.cpuUsage")}
      data={
        data_cpu_usage && data_cpu_usage.length > 0
          ? convertToChartData(data_cpu_usage[0].values, 1, unitObjectCPU)
          : []
      }
      lineColor="#22C55E"
      suffix={unitObjectCPU && unitObjectCPU.Unit}
      maxY={maxY}
      ytitle={"CPU"}
      xtitle="Time"
      data-test="chart-card"
      chartLabel = "CPU"
    />
  );
};

export default withTranslation()(CPUChartCard);
